<template>
  <main-content-layout
    :title="$gettext('COMMUNICATION_HISTORY')"
  >
    <div class="communication-history-page tw-p-5">
      <communication-history-grid
        :consumer-unit="consumerUnitNumber"
      />
    </div>
  </main-content-layout>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
import CommunicationHistoryGrid from 'src/modules/concession/messaging/history/CommunicationHistoryGrid.vue'

@Component({
  name: 'CommunicationHistory',
  components: {
    MainContentLayout,
    CommunicationHistoryGrid
  },
  props: {
    consumerUnit: [String, Number]
  }
})
class CommunicationHistory extends Vue {
  get consumerUnitNumber () {
    const parsedValue = Number(this.consumerUnit)
    return Number.isNaN(parsedValue) ? 0 : parsedValue
  }
}

export default CommunicationHistory
</script>

<style lang="stylus" scoped>
.communication-history-page
  width: 100%
  height: 100%
</style>
